// Client-side validation of account fields (rules from docs/ARCHITECTURE.md "REST API").
// Each validator returns an error message, or null when the value is acceptable.

const USERNAME_RE = /^[A-Za-z0-9_]{3,16}$/;

export const DISPLAY_NAME_MIN = 2;
export const DISPLAY_NAME_MAX = 20;

/** Control characters, invisible/format characters and any whitespace except a plain space. */
const UNPRINTABLE = /[\p{Cc}\u00AD\u061C\u180E\u200B-\u200F\u202A-\u202E\u2060-\u206F\uFEFF\uFFF9-\uFFFC]|[^\S ]/u;

export const PASSWORD_MIN = 8;
export const PASSWORD_MAX = 128;

/** Trimmed, 2..20 characters (counted as code points), printable only. */
export function validateDisplayName(value: string): string | null {
  const name = value.trim();
  if (UNPRINTABLE.test(name)) return "Use printable characters only (no tabs, line breaks or invisible characters).";
  const length = Array.from(name).length;
  if (length < DISPLAY_NAME_MIN) return `At least ${DISPLAY_NAME_MIN} characters.`;
  if (length > DISPLAY_NAME_MAX) return `At most ${DISPLAY_NAME_MAX} characters (${length} entered).`;
  return null;
}

export function validateUsername(value: string): string | null {
  return USERNAME_RE.test(value) ? null : "Use 3 to 16 letters, digits or underscores.";
}

export function validatePassword(value: string): string | null {
  if (value.length < PASSWORD_MIN) return `Use at least ${PASSWORD_MIN} characters.`;
  if (value.length > PASSWORD_MAX) return `Use at most ${PASSWORD_MAX} characters.`;
  return null;
}
